import { render, staticRenderFns } from "./PersistResponseRoboCnpjView.vue?vue&type=template&id=f7234ab4&"
import script from "./PersistResponseRoboCnpjView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponseRoboCnpjView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports